var _rect, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNotconfirmed(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 85,
    height: 85,
    viewBox: "0 0 85 85",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 85,
    height: 85,
    rx: 42.5,
    fill: "#FFEBEB"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M54.75 33.2175L52.2825 30.75L42.5 40.5325L32.7175 30.75L30.25 33.2175L40.0325 43L30.25 52.7825L32.7175 55.25L42.5 45.4675L52.2825 55.25L54.75 52.7825L44.9675 43L54.75 33.2175Z",
    fill: "#E74141"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotconfirmed);
export default __webpack_public_path__ + "static/media/not confirmed.06ddcc842fe24dd6c9b396f00357c7de.svg";
export { ForwardRef as ReactComponent };